import Navbar from "./components/Navbar";
import React, { useRef } from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import { Archivements } from "./utils/Archivements";
import { IoArrowBack } from "react-icons/io5";
import { FiExternalLink } from "react-icons/fi";
import { Link } from "react-router-dom";

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const StyledTableContainer = styled.div`
  margin: 50px -20px;

  @media (max-width: 768px) {
    margin: 50px -10px;
  }

  table {
    width: 100%;
    border-collapse: collapse;

    .hide-on-mobile {
      @media (max-width: 768px) {
        display: none;
      }
    }

    tbody tr {
      &:hover,
      &:focus {
        background-color: var(--light-navy);
      }
    }

    th,
    td {
      padding: 10px;
      text-align: left;

      &:first-child {
        padding-left: 20px;

        @media (max-width: 768px) {
          padding-left: 10px;
        }
      }
      &:last-child {
        padding-right: 20px;

        @media (max-width: 768px) {
          padding-right: 10px;
        }
      }

      svg {
        width: 20px;
        height: 20px;
      }
    }

    tr {
      cursor: default;

      td:first-child {
        border-top-left-radius: var(--border-radius);
        border-bottom-left-radius: var(--border-radius);
      }
      td:last-child {
        border-top-right-radius: var(--border-radius);
        border-bottom-right-radius: var(--border-radius);
      }
    }

    td {
      &.year {
        padding-right: 20px;

        @media (max-width: 768px) {
          padding-right: 10px;
          font-size: var(--fz-sm);
        }
      }

      &.title {
        padding-top: 15px;
        padding-right: 20px;
        color: var(--lightest-slate);
        font-size: var(--fz-xl);
        font-weight: 600;
        line-height: 1.25;
      }

      &.company {
        font-size: var(--fz-lg);
        white-space: nowrap;
      }

      &.tech {
        font-size: var(--fz-xxs);
        font-family: var(--font-mono);
        line-height: 1.5;
        .separator {
          margin: 0 5px;
        }
        span {
          display: inline-block;
        }
      }

      &.links {
        min-width: 100px;

        div {
          display: flex;
          align-items: center;

          a {
            flex-shrink: 0;
          }

          a + a {
            margin-left: 10px;
          }
        }
      }
    }
  }
`;

const ArchivePage = () => {
  const revealTitle = useRef(null);
  const revealTable = useRef(null);
  const revealProjects = useRef([]);
  const mainRef = useRef(false);

  const toggleBlur = () => {
    mainRef.current.classList.toggle("blurBody");
  };

  return (
    <StyledContent>
      <Navbar toggle={() => toggleBlur()} isArchieve={true} />
      <Helmet title="Archive" />
      <main
        ref={mainRef}
        className="text-white mt-28 h-screen px-[25px] sm:px-[50px] md:px-[100px] lg:px-[150px]"
      >
        <header ref={revealTitle}>
          <div>
            <Link to="/">
              <IoArrowBack
                color="#11ABBC"
                size={50}
                className="cursor-pointer"
              />
            </Link>
          </div>
          <h1 className="text-gray-200 text-5xl lg:text-[5rem] font-semibold">
            Achievements
          </h1>
          <p className="text-theme-green text-base lg:text-lg tracking-wider">
            A big list of things I’ve achieved
          </p>
        </header>

        <StyledTableContainer ref={revealTable}>
          <table>
            <thead>
              <tr>
                <th>Year</th>
                <th>Title</th>
                <th>Description</th>
                <th>Link</th>
              </tr>
            </thead>
            <tbody>
              {Archivements.map((item, idx) => (
                <tr>
                  <td className="text-theme-green text-base font-semibold">
                    {item.year}
                  </td>
                  <td className="text-base text-theme-gray-deep font-semibold">
                    {item.title}
                  </td>
                  <td className="text-white font-bold">{item.description}</td>
                  {item.link !== "" && (
                    <td>
                      <a target="_blank" href={item.link}>
                        <FiExternalLink
                          className="text-gray-500 hover:text-theme-green"
                          size={20}
                        />
                      </a>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </StyledTableContainer>
      </main>
    </StyledContent>
  );
};

export default ArchivePage;
